import { OMFZ_EXTENSION } from '../types/driveArchive';
import type { DriveOmfzFile } from './driveApi';

/**
 * Drive 履歴の表示タイトル (issue #144 / #146)。 description があればそれを優先し、
 * 欠落時は name から技術的な拡張子 (.omfz) を除去してユーザーに露出させない。
 * description が空文字なら空文字を尊重する (?? のため name フォールバックへ落ちない)。
 */
export function driveHistoryTitle(file: DriveOmfzFile): string {
  const fallback = file.name.endsWith(OMFZ_EXTENSION)
    ? file.name.slice(0, -OMFZ_EXTENSION.length)
    : file.name;
  return file.description ?? fallback;
}
